module.exports = __webpack_public_path__ + "img/clz.89f79eff.png";